
import BaseApiController from 'controller/baseresourcecontroller';

export default class BasketDetailController extends BaseApiController {
  constructor () {
    super('mvc/basketdetail');
  }

  async GetDetail (autoid) {
    return super.Get(`GetDetail?orderid=${autoid}`);
  }

  async GetDefault () {
    return super.Get('GetDefault');
  }
  
  async GetOrderLines (autoid, search, pagesize = 10, pageindex = 0) {
    return super.Post(`GetOrderLines`, { SearchKey: search, PageSize: pagesize, PageIndex: pageindex, OrderID: autoid });
  }

  async GetActiveBasketInfo () {
    return super.Get('GetActiveBasketInfo');
  }

  async UpdateOrderLineQuantity (orderlineid, newquantity) {
    return super.Post('UpdateOrderLineQuantity', { orderlineid: orderlineid, newquantity: newquantity });
  }

  async GetOrderLine (orderlineid) {
    return super.Get(`GetOrderLine?AutoID=${orderlineid}`);
  }

  async UpdateOrderLine (data) {
    return super.Post('UpdateOrderLine', data);
  }

  async InsertTextOrderLine (data) {
    return super.Post('InsertTextOrderLine', data);
  }

  async UpdateBasket (data) {
    return super.Post('UpdateBasket', data);
  }

  async RemoveOrderLine (orderlineid) {
    return super.Post('RemoveOrderLine', {orderlineid: orderlineid});
  }

  async CalculateDeliveryDate (vm) {
    return super.Post('CalculateDeliveryDate', vm);
  }

  async LocationChanged (viewmodel, locationid) {
    return super.Post('LocationChanged', {current: viewmodel, locationid: locationid});
  }

  async ApplyBudgetCodeOnOrderLines (data) {
    return super.Post('ApplyBudgetCodeOnOrderLines', data);
  }
  async Delete (autoid) {
    return super.Post('delete', { autoid: autoid });
  }

  async GetAllowShoppingCartTextLine () {
    return super.Get('GetAllowShoppingCartTextLine');
  }
}